import React from 'react';
import CorporateTours from '../../../assets/Service-icon/currency exchange.svg';
import DestinationWeddings from '../../../assets/Service-icon/wide range.svg';
import ConferenceManagement from '../../../assets/Service-icon/Visa process.svg';
import EventPlanning from '../../../assets/Service-icon/track.svg';

const Steps = () => {
  const options = [
    {
      id: 1,
      img: CorporateTours,
      desc: 'Travel with ease and enjoy your trip without worrying about currency exchange rates.',
    },
    {
      id: 2,
      img: DestinationWeddings,
      desc: 'Choose from a wide range of currencies and get them delivered to your doorstep or pick them up from our branches.',
    },
    {
      id: 3,
      img: ConferenceManagement,
      desc: 'We process your visa application and submit it to the consulate/embassy.',
    },
    {
      id: 4,
      img: EventPlanning,
      desc: 'We track and update you on your visa status',
    },
  ];

  return (
    <div className='mb-10 px-4 py-10 text-center'>
      {/* Main Heading */}
      <h1 className='mb-12 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
        Plan Your Journey with Ease
      </h1>

      {/* Grid */}
      <div className='mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg'
          >
            <img
              src={item.img}
              alt={item.step}
              className='mb-4 h-24 w-24 object-contain'
            />

            <p className='text-justify leading-relaxed text-gray-700'>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Steps;
